import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import apiService from "../../../api/apiService";
import TablePagination from "@mui/material/TablePagination";
import DataContext from "../../../context/DataContext";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CustomLink from "../../common-page/CustomLink";
const SearchinputDiv = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  color: "black",
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "18ch",
      backgroundColor: '#2e55d14f',
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));
const TanseedAllJuryPendingList = ({ path, value }) => {
  const { tableIndexValue, setPageLoading, statupSide, } = useContext(DataContext);
  const [count, setCount] = useState(0);
  var pageNumberPartners = Number(localStorage.getItem("pageScst"));
  const [page, setPage] = useState(pageNumberPartners ? pageNumberPartners : 0);
  var listSizePartners = Number(localStorage.getItem("rowsPerPageScst"));
  const [rowsPerPage, setRowsPerPage] = useState(
    listSizePartners ? listSizePartners : 10
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("pageScst", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem("rowsPerPageScst", parseInt(event.target.value, 10));
    localStorage.setItem("pageScst", 0);
    setPage(0);
  };
  var searchInputValueJury = localStorage.getItem("tanseedJuryPendingList");
  const [searchInputValue, setSearchInputValue] = useState(
    searchInputValueJury ? searchInputValueJury : ""
  );
  const [searchName, setSearchName] = useState(searchInputValueJury ? searchInputValueJury : "");
  useDidMountEffect(() => {
    setSearchInputValue("");
  }, []);
  useDidMountEffect(() => {
    listApi();
  }, [
    page,
    rowsPerPage,
    searchInputValue,
    statupSide,
  ]);
  const handleSearch = (searchValue) => {
    if (searchValue.length > 3) {
      setSearchInputValue(searchValue);
      localStorage.setItem("tanseedJuryPendingList", searchValue);
      setPage(0);
    } else {
      setSearchInputValue('');
      localStorage.setItem("tanseedJuryPendingList", "");
      setPage(0);
    }
    setSearchName(searchValue);
  };
  const [startupListData, setStartupListData] = useState([]);

  const listApi = async () => {
    setStartupListData([]);
    setPageLoading(true);
    var req = {
      listSize: rowsPerPage,
      pageNumber: page + 1,
      searchString: searchName !== "" ? searchInputValue : "",
      approvalPending: false,
    };
    apiService('jury/tanseed/startup/list', req, "post").then((res) => {
      setPageLoading(false);
      if (res) {
        setCount(res.data.count);
        if (res.data.startups) {
          setStartupListData(res.data.startups);
        }
      }
    });
  };
  return (
    <section className="">
      <div className="container-fluid">
        <div className="">
          <div className="header_tag">
            {/* <h5>Associated Startups</h5> */}
            <div className="">
              <SearchinputDiv
                sx={{ display: { xs: "none", sm: "block" } }}
                onChange={(e) => handleSearch(e.target.value)}
              >
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  value={searchName}
                  placeholder="Search for a Startup"
                  type="search"
                  inputProps={{ "aria-label": "Search for a Startup" }}
                />
              </SearchinputDiv>
            </div>
          </div>
          <div className="table_tag">
            {startupListData.length ? (
              <TableContainer component={Paper}>
                <TablePagination
                  component="div"
                  count={count}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  style={{ float: "left" }}
                />
                <Table sx={{ minWidth: 650 }} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">No</TableCell>
                      <TableCell>Startup Name</TableCell>
                      <TableCell>Partner Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {startupListData.map((list, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {tableIndexValue(rowsPerPage, page, index)}
                        </TableCell>
                        <TableCell>
                          <CustomLink
                            to={
                              `/${path}/details/${btoa(
                                list.startupId
                              )}/${btoa(list.partnerOrInvestorId)}`
                            }
                          >
                            {list.startupName ?? `-`}
                          </CustomLink>
                        </TableCell>
                        <TableCell>
                          {list.partnerName ? list.partnerName : "-"}
                        </TableCell>
                        <TableCell>
                          {list.email ? list.email : "-"}
                        </TableCell>
                        <TableCell>
                          {list.phone ? list.phone : "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <caption>
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      style={{ float: "left" }}
                    />
                  </caption>
                </Table>
              </TableContainer>
            ) : (
              <div className="nodata_tag">
                <img
                  src="/images/Tanfundlogo-black-1.png"
                  className="no_data_logo"
                  alt=""
                />
                <h4>No Records Found</h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default TanseedAllJuryPendingList;

